import { render, staticRenderFns } from "./TableVisibilityConfig.vue?vue&type=template&id=0231faae&scoped=true"
import script from "./TableVisibilityConfig.vue?vue&type=script&lang=js"
export * from "./TableVisibilityConfig.vue?vue&type=script&lang=js"
import style0 from "./TableVisibilityConfig.vue?vue&type=style&index=0&id=0231faae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231faae",
  null
  
)

export default component.exports